<template>
  <div class="funnel-chart">
    <div ref="chart" class="funnel-chart-canvas"></div>
    <div v-if="isEmpty" class="funnel-chart-empty">Немає даних за обраний період</div>
  </div>
</template>

<script>
// Only the modules the funnel needs, to keep the bundle small
// (a custom series: the built-in funnel series cannot draw curved sides)
import { use, init } from "echarts/core";
import { CustomChart } from "echarts/charts";
import { TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { buildFunnelOption, isEmptyFunnel } from "./funnelChartOption";

use([CustomChart, TooltipComponent, CanvasRenderer]);

export default {
  name: "FunnelChart",
  props: {
    // [{ title, users, fromStart, fromPrevious }]
    steps: { type: Array, required: true },
  },
  data() {
    return { chart: null, resizeObserver: null };
  },
  computed: {
    isEmpty() {
      return isEmptyFunnel(this.steps);
    },
  },
  watch: {
    steps: {
      deep: true,
      handler() {
        this.render();
      },
    },
  },
  methods: {
    render() {
      if (this.chart) this.chart.setOption(buildFunnelOption(this.steps), true);
    },
    resize() {
      if (this.chart) this.chart.resize();
    },
  },
  mounted() {
    this.chart = init(this.$refs.chart, null, { renderer: "canvas" });
    this.render();
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.$refs.chart);
    } else {
      window.addEventListener("resize", this.resize);
    }
  },
  beforeUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener("resize", this.resize);
    if (this.chart) this.chart.dispose();
    this.chart = null;
  },
};
</script>

<style scoped>
.funnel-chart {
  position: relative;
  max-width: 1100px;
  margin-bottom: 24px;
}
.funnel-chart-canvas {
  width: 100%;
  height: 300px;
}
.funnel-chart-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a5a8b0;
  font-size: 14px;
}
</style>
